@if (visible()) {
  <div class="tenant-inactive-backdrop" role="presentation" (click)="dismissed.emit()">
    <div
      class="tenant-inactive-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tenant-inactive-title"
      (click)="$event.stopPropagation()"
    >
      <button type="button" class="tenant-inactive-close" (click)="dismissed.emit()" aria-label="Close">
        ×
      </button>
      <p class="tenant-inactive-brand">LaunchPocket</p>
      <div class="tenant-inactive-hero" aria-hidden="true">
        <span class="tenant-inactive-hero-icon">!</span>
      </div>

      <h2 id="tenant-inactive-title" class="tenant-inactive-title">
        Account inactive
      </h2>
      <p class="tenant-inactive-subtitle">
        <strong>{{ displayTenant() }}</strong> is inactive. Please contact LaunchPocket support to regain access.
      </p>

      <div class="tenant-inactive-actions">
        <a class="btn btn-primary" [href]="mailtoHref()">
          Email support
          <span aria-hidden="true">→</span>
        </a>
        <p class="tenant-inactive-fallback">
          If the button doesn’t work, email us at
          <strong>{{ supportEmail() }}</strong>.
        </p>
      </div>
    </div>
  </div>
}

